import type { LucideIcon, LucideProps } from 'lucide-react';

export type IconProps = LucideProps;

/**
 * Default props for decorative icons used inside labeled buttons/controls.
 * Spread onto lucide icons: `<X {...defaultIconProps} size={16} />`
 */
export const defaultIconProps: Partial<IconProps> = {
  size: 20,
  strokeWidth: 2,
  'aria-hidden': true,
};

/**
 * Merge default decorative icon props with overrides.
 */
export function createIconProps(overrides?: Partial<IconProps>): Partial<IconProps> {
  return { ...defaultIconProps, ...overrides };
}

export type { LucideIcon };

export {
  X,
  Plus,
  Minus,
  ChevronLeft,
  ChevronRight,
  ChevronDown,
  Search,
  Check,
  CheckCircle,
  XCircle,
  Info,
  Trash2,
  ShoppingBag,
  Image as ImageIcon,
  ZoomIn,
  ArrowLeft,
} from 'lucide-react';
